module.exports = __webpack_public_path__ + "img/department-line-green.5d40cccf.svg";